var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4094 5.20001H4.55005C4.12817 5.20001 3.80005 4.87189 3.80005 4.45001C3.80005 4.07501 4.12817 3.70001 4.55005 3.70001H22.55C22.925 3.70001 23.3 3.37189 23.3 2.95001C23.3 1.73126 22.2688 0.700012 21.05 0.700012H3.80005C2.11255 0.700012 0.800049 2.05939 0.800049 3.70001V18.7C0.800049 20.3875 2.11255 21.7 3.80005 21.7H22.4094C23.7219 21.7 24.8 20.7156 24.8 19.45V7.45001C24.8 6.23126 23.7219 5.20001 22.4094 5.20001ZM20.3 14.95C19.4563 14.95 18.8 14.2938 18.8 13.45C18.8 12.6531 19.4563 11.95 20.3 11.95C21.0969 11.95 21.8 12.6531 21.8 13.45C21.8 14.2938 21.0969 14.95 20.3 14.95Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.bae2fc952842affa8c84e58dc8a194a9.svg";
export { ForwardRef as ReactComponent };